import React from 'react'

function ProfileInitial({ name = 'John', width = 62, height = 62, bgColor = 'bg-teal-100 text-green-900', fontSize = 'text-2xl' }) {
    const initial = name?.charAt(0);
    return (
        <div
            style={{ width, height }}
            className={`uppercase flex flex-none items-center justify-center ${fontSize} ${bgColor}`}
        >
            {initial}
        </div>
    )
}

export default ProfileInitial;